const e = "_uploadContainer_1xzwl_1", t = "_drag_1xzwl_8", a = "_attachmentCardContainer_1xzwl_16", n = "_rejectedFile_1xzwl_19", r = "_rejectedTypeContainer_1xzwl_23", o = {
  uploadContainer: e,
  drag: t,
  attachmentCardContainer: a,
  rejectedFile: n,
  rejectedTypeContainer: r
};
export {
  a as attachmentCardContainer,
  o as default,
  t as drag,
  n as rejectedFile,
  r as rejectedTypeContainer,
  e as uploadContainer
};
//# sourceMappingURL=FileUpload.module.scss.js.map
